import userflow from "userflow.js";
import { env } from "../infrastructure/environment";
import { getCurrentTenantFromStorage } from "../infrastructure/tenant";
import { User } from "../types/globals";

// Docs: https://docs.userflow.com/docs/userflow-js#userflow-js-reference

if (env.USERFLOW_TOKEN) {
  userflow.init(env.USERFLOW_TOKEN);
}

async function identifyUser(user: User) {
  if (env.USERFLOW_TOKEN) {
    userflow.identify(user.b2cObjectId, {
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      locale_code: navigator.language,
      device_type: window.innerWidth > 800 ? "desktop" : "mobile",
    });
    const currentTenant = await getCurrentTenantFromStorage();
    if (currentTenant) {
      userflow.group(currentTenant.id);
    }

    // Start a flow if one was requested via ?userflow=<id>.
    // The param may come from the current URL or from sessionStorage (saved
    // before a B2C redirect to survive the round-trip).
    const pendingSearch = sessionStorage.getItem("pendingSearch") ?? "";
    const urlParams = new URLSearchParams(window.location.search || pendingSearch);
    const flowId = urlParams.get("userflow");
    if (flowId) {
      // Keep sessionStorage up-to-date so the ID survives any subsequent hard
      // redirect (e.g. requestPilets redirecting to /iam/resourceselection).
      sessionStorage.setItem("pendingSearch", urlParams.toString() ? `?${urlParams}` : "");

      // Only start the flow once we are on the real app page, not during IAM/auth
      // transit routes where the flow targets won't match the current page anyway.
      const isTransitRoute =
        window.location.pathname === "/" ||
        window.location.pathname.startsWith("/iam/") ||
        window.location.pathname.startsWith("/iam-user/") ||
        window.location.pathname.startsWith("/authentication/");

      if (!isTransitRoute) {
        sessionStorage.removeItem("pendingSearch");
        userflow.startFlow(flowId);
      }
    }
  }
}

export { identifyUser };
